/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CloudModule
 */

/**
 * @fileoverview Contains Ajs dependency tokens for factories & components.
 *
 * @author Sarthak Kapoor
 */

/**
 * Dependency token for Cloud Connector User Collection.
 */
export const CLOUD_CONNECTOR_USER_COLLECTION_TOKEN = 'CloudConnectorUserCollection';
